window.app = function (app) {

	app.ver = "0.3.697";

	return app;

}(window.app || {});